const mappedQuestionIdIcons = {
  first_name: 'person',
  last_name: 'person',
  your_first_name: 'person',
  postcode: 'zipcode',
  primary_address_postalcode: 'zipcode',
  primary_address_city: 'city',
  primary_address_state: 'state',
  phone_work: 'phone',
  phone_mobile: 'phone',
  email1: 'email',
  company_name: 'company',
  country: 'globe',
};

export default mappedQuestionIdIcons;
